/**
 * NotesCapture — the fast-dump capture box (Messaging Notes).
 * Content is the only required field; visibility defaults to private.
 * Trust carve-out #6: the one-line policy names the exclusions inline.
 */

import React, { useState } from 'react';
import { NOTE_TYPE_OPTIONS, NOTE_VIS_OPTIONS } from '@techstack/core';

function NotesCapture({ account, saveNote, notice }) {
  const [draft, setDraft] = useState('');
  const [type, setType] = useState('general');
  const [vis, setVis] = useState('private');
  const saving = saveNote.isPending;

  const save = () => {
    const content = draft.trim();
    if (!content || saving) return;
    saveNote.mutate({ content, type, visibility: vis }, { onSuccess: () => setDraft('') });
  };

  return (
    <div className="aw-notes-capture">
      <textarea
        value={draft}
        rows={3}
        disabled={saving}
        aria-label="New note"
        placeholder={`Dump a thought about ${account}… (Cmd+Enter saves)`}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') { e.preventDefault(); save(); }
        }}
      />
      {/* Two chip rows (7 type chips + 3 visibility pills) collapsed into
          two compact selects — audit slice 3, "chips capped". */}
      <div className="aw-notes-controls">
        <select
          className="aw-notes-select"
          value={type}
          disabled={saving}
          aria-label="Note category"
          onChange={(e) => setType(e.target.value)}
        >
          {NOTE_TYPE_OPTIONS.map(([key, label]) => (
            <option key={key} value={key}>{label}</option>
          ))}
        </select>
        <select
          className="aw-notes-select"
          value={vis}
          disabled={saving}
          aria-label="Note visibility"
          title={(NOTE_VIS_OPTIONS.find(([key]) => key === vis) || [])[2] || ''}
          onChange={(e) => setVis(e.target.value)}
        >
          {NOTE_VIS_OPTIONS.map(([key, label]) => (
            <option key={key} value={key}>{label}</option>
          ))}
        </select>
        <span className="aw-notes-spacer" />
        <button type="button" className="aw-notes-save" disabled={saving || !draft.trim()} onClick={save}>
          {saving ? 'Saving…' : 'Save note'}
        </button>
      </div>
      <p className="aw-notes-policy"
        title="Private notes are yours alone; Team shares with this account's assigned AE/SC; Public shares with everyone who can see this account. Same notes appear in the GAS dashboard.">
        Private by default · no customer-confidential info, contract terms, or PII in shared notes
      </p>
      {notice && (
        <p className={notice.kind === 'err' ? 'aw-notes-error' : 'aw-notes-notice'} role="status">{notice.text}</p>
      )}
    </div>
  );
}

export default NotesCapture;
